import React, { ChangeEvent, MouseEventHandler, useEffect, useState } from "react";
import LabResultMobile from "./LabResultMobile";
import LabResultRow from "./LabResultRow";
import { useDispatch, useSelector } from "react-redux";
import {
  test,
  testsuccessMessage,
  totalPages,
  totalRecords,
  testError,
  testActivityInProcess,
} from "redux-store/lab-tests/tests.selecter";
import { getAllTests, getsubmittedTests, getnotsubmittedTests, petTestsClean } from "redux-store/lab-tests/tests.slice";
import { AppDispatch } from "redux-store/store";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import Loader from "components/loader/Loader";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate, useSearchParams } from "react-router-dom";
const LabResultTable = () => {
  // let tests = useSelector(test);
  const [tests, setTests] = useState([]);
  const dispatch = useDispatch<AppDispatch>();
  const loading = useSelector(testActivityInProcess);
  const testsUpdated = useSelector(testsuccessMessage);
  const errorMessage = useSelector(testError);
  const [submited, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const search = searchParams.get("search");
  let pages = useSelector(totalPages);
  const [activePage, setActivePage] = useState(1);
  const [pageValue, setPageValue] = useState({
    start: 1,
    second: 2,
    end: 3,
  });
  const [activeFilter, setActiveFilter] = useState({
    submit: false,
    notSubmit: false,
    all: true,
  });
  const [sortedResults, setsortedResults] = useState<any>([]);
  const [downOpenForPet, setDownForPet] = useState(false);
  const [downOpenForUser, setDownForUser] = useState(false);
  const [records, setRecords] = useState(0);
  const [searchedUser, setSearchedUser] = useState<string>("");
  const changeFilter = (value: any) => {
    setsortedResults([]);
    if (value === "submit") {
      setActiveFilter({
        ...activeFilter,
        submit: true,
        notSubmit: false,
        all: false,
      });
      setActivePage(1);
      dispatch(petTestsClean());
      dispatch(getsubmittedTests(1)).then((res) => {
        setRecords(res.payload.totalresults);

        setTests(res.payload.labResults);
      });
    } else if (value === "notsubmit") {
      setActiveFilter({
        ...activeFilter,
        submit: false,
        notSubmit: true,
        all: false,
      });
      setActivePage(1);
      dispatch(petTestsClean());
      dispatch(getnotsubmittedTests(1)).then((res) => {
        setRecords(res.payload.totalresults);

        setTests(res.payload.labResults);
      });
    } else if (value === "all") {
      setActiveFilter({
        ...activeFilter,
        submit: false,
        notSubmit: false,
        all: true,
      });
      setActivePage(1);
      dispatch(petTestsClean());

      dispatch(getAllTests({ page: 1 })).then((res) => {
        setRecords(res.payload.totalResults);
        setTests(res.payload.labResults);
      });
    }
  };
  const incrementPageHandler = () => {
    setPageValue({
      ...pageValue,
      start: pageValue.start + 1,
      second: pageValue.second + 1,
      end: pageValue.end + 1,
    });
  };
  const decrementPageHandler = () => {
    setPageValue({
      ...pageValue,
      start: pageValue.start - 1,
      second: pageValue.second - 1,
      end: pageValue.end - 1,
    });
  };
  const onPageClickHandler = (pageNumber: any) => {
    dispatch(petTestsClean());
    setActivePage(pageNumber);
    setsortedResults([]);
    if (activeFilter.submit) {
      dispatch(getsubmittedTests(activePage)).then((res) => console.log(res));
    } else if (activeFilter.notSubmit) {
      dispatch(getnotsubmittedTests(activePage)).then((res) => console.log(res));
    } else {
      dispatch(getAllTests({ page: pageNumber })).then((res) => {
        setRecords(res.payload.totalResults);
        setTests(res.payload.labResults);
      });
    }
  };

  useEffect(() => {
    dispatch(getAllTests({ page: 1 })).then((res) => {
      setRecords(res.payload.totalResults);

      setTests(res.payload.labResults);
    });
  }, []);

  useEffect(() => {
    if (testsUpdated === "Result submitted successfully") {
      if (activeFilter.notSubmit) {
        dispatch(getnotsubmittedTests(activePage));
      } else if (activeFilter.all) {
        dispatch(getAllTests({ page: activePage })).then((res) => {
          setRecords(res.payload.totalResults);
          setTests(res.payload.labResults);
        });
      }
    }
  }, [testsUpdated]);

  useEffect(() => {
    if (errorMessage.message === "Result not found") {
      dispatch(petTestsClean());
    }
  }, [errorMessage]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1024);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);
  const ascPetSortHandler = () => {
    const sortedTests = tests && [...tests].sort((a: any, b: any) => a.petId?.petName.localeCompare(b.petId?.petName));
    setsortedResults(sortedTests);
    setDownForPet(true);
  };

  const descPetSortHandler = () => {
    const sortedTests = tests && [...tests].sort((a: any, b: any) => b.petId?.petName.localeCompare(a.petId?.petName));
    setsortedResults(sortedTests);
    setDownForPet(false);
  };

  const ascUserSortHandler = () => {
    const sortedTests =
      tests && [...tests].sort((a: any, b: any) => a.userId.fullName.localeCompare(b.userId.fullName));
    setsortedResults(sortedTests);
    setDownForUser(true);
  };
  const descUserSortHandler = () => {
    const sortedTests =
      tests && [...tests].sort((a: any, b: any) => b.userId.fullName.localeCompare(a.userId.fullName));
    setsortedResults(sortedTests);
    setDownForUser(false);
  };

  const getUsername = (e: ChangeEvent<HTMLInputElement>) => {
    const name = e.target.value;
    setActivePage(1);
    setSearchedUser(name);
  };

  const handleSearchUser = (e: any) => {
    e.preventDefault();
    navigate(`/admin/lab-result?search=${searchedUser}`);
  };
  useEffect(() => {
    dispatch(getAllTests({ page: activePage, userName: (search as string) || "" })).then((res) => {
      setRecords(res.payload.totalResults);
      setTests(res.payload.labResults);
    });
  }, [search, activePage]);

  const testLength = tests?.length;
  return (
    <>
      {isMobile ? (
        <>
          <div className="tw-flex tw-justify-center tw-items-center">
            <label className="tw-px-2">
              <input
                type="checkbox"
                className="tw-mr-2"
                onChange={() => {
                  changeFilter("submit");
                }}
                checked={activeFilter.submit ? true : false}
              />
              Submitted
            </label>
            <label className="tw-px-2">
              <input
                type="checkbox"
                className="tw-mr-2"
                onChange={() => {
                  changeFilter("notsubmit");
                }}
                checked={activeFilter.notSubmit ? true : false}
              />
              Not Submitted
            </label>
            <label className="tw-px-2">
              <input
                type="checkbox"
                className="tw-mr-2"
                onChange={() => {
                  changeFilter("all");
                }}
                checked={activeFilter.all ? true : false}
              />
              All
            </label>
          </div>
          {tests && tests?.length !== 0 ? (
            <>
              {tests &&
                tests?.length > 0 &&
                tests?.map((item: any) => <LabResultMobile key={item?._id} result={item} isSubmitted={item?.submit} />)}
              {/* <div className="tw-w-full tw-m-auto tw-flex tw-flex-col md:tw-flex-row tw-gap-[1rem] tw-items-center md:tw-justify-between sm:tw-justify-center tw-px-[10%] tw-mt-[2rem]"> */}
              {/* <div className="">
                  <p className="tw-text-base tw-text-tabelHeadingColor tw-font-fontPara tw-font-medium">
                    {`Showing ${testLength}
                           of ${records}`}
                  </p>
                </div> */}
              {/* <div className="flex flex-row gap-[0.5rem] tw-items-center">
                  <button
                    onClick={decrementPageHandler}
                    disabled={pageValue.start <= 1 ? true : false}
                    className={
                      pageValue.start <= 1
                        ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                        : "tw-px-[0.5rem] md:tw-px-[1.05rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-sm md:tw-text-md tw-rounded-md tw-text-white tw-font-fontHeading tw-font-bold tw-bg-reddishOrange tw-mr-1"
                    }
                  >
                    <KeyboardDoubleArrowLeftIcon />
                  </button>
                  <button
                    disabled={pageValue.start > pages ? true : false}
                    className={
                      pageValue.start === activePage
                        ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-2"
                        : pageValue.start > pages
                        ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-2"
                        : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md tw-mr-2 hover:tw-bg-reddishOrange hover:tw-text-white"
                    }
                    onClick={() => onPageClickHandler(pageValue.start)}
                  >
                    {pageValue.start}
                  </button>
                  <button
                    disabled={pageValue.second > pages ? true : false}
                    className={
                      pageValue.second === activePage
                        ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-2"
                        : pageValue.second > pages
                        ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-2"
                        : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md tw-mr-2 hover:tw-bg-reddishOrange hover:tw-text-white"
                    }
                    onClick={() => onPageClickHandler(pageValue.second)}
                  >
                    {pageValue.second}
                  </button>
                  <button
                    disabled={pageValue.end > pages ? true : false}
                    className={
                      pageValue.end === activePage
                        ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-1"
                        : pageValue.end > pages
                        ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                        : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md hover:tw-bg-reddishOrange hover:tw-text-white tw-mr-1"
                    }
                    onClick={() => onPageClickHandler(pageValue.end)}
                  >
                    {pageValue.end}
                  </button>
                  <button
                    onClick={incrementPageHandler}
                    disabled={pageValue.end >= pages ? true : false}
                    className={
                      pageValue.end >= pages
                        ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                        : "tw-px-[0.5rem] md:tw-px-[1.05rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-sm md:tw-text-md tw-rounded-md tw-text-white tw-font-fontHeading tw-font-bold tw-bg-reddishOrange tw-mr-1"
                    }
                  >
                    <KeyboardDoubleArrowRightIcon />
                  </button>
                </div> */}
              {/* </div> */}
            </>
          ) : (
            ""
          )}
          {loading && <Loader />}
          {!loading && tests && tests?.length === 0 && "No Result Found"}
        </>
      ) : (
        <>
          <div className="tw-grid tw-grid-cols-2 tw-place-items-center tw-max-w-[95%] tw-gap-4 tw-w-full tw-mx-auto">
            <div className="tw-flex tw-justify-center tw-w-full">
              <label className="tw-px-2">
                <input
                  type="checkbox"
                  className="tw-mr-2"
                  onChange={() => changeFilter("submit")}
                  checked={activeFilter.submit ? true : false}
                />
                Submitted
              </label>
              <label className="tw-px-2">
                <input
                  type="checkbox"
                  className="tw-mr-2"
                  onChange={() => changeFilter("notsubmit")}
                  checked={activeFilter.notSubmit ? true : false}
                />
                Not Submitted
              </label>
              <label className="tw-px-2">
                <input
                  type="checkbox"
                  className="tw-mr-2"
                  onChange={() => changeFilter("all")}
                  checked={activeFilter.all ? true : false}
                />
                All
              </label>
            </div>

            <form className="tw-w-[80%]">
              <label className="tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-sr-only dark:tw-text-white">
                Search
              </label>
              <div className="tw-relative">
                <div className="tw-absolute tw-inset-y-0 tw-start-0 tw-flex tw-items-center tw-ps-3 tw-pointer-events-none">
                  <svg
                    className="tw-w-4 tw-h-4 tw-text-gray-500 dark:tw-text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    />
                  </svg>
                </div>

                <input
                  type="search"
                  id="search"
                  className="tw-block tw-w-full tw-p-4 tw-ps-10 tw-border tw-border-gray-300 dark:tw-placeholder-gray-400 tw-text-#000"
                  placeholder="Search"
                  value={searchedUser}
                  required
                  onChange={getUsername}
                />

                <button
                  onClick={handleSearchUser}
                  type="submit"
                  className="tw-text-white tw-absolute tw-end-2.5 tw-bottom-2.5 tw-bg-blue-700 hover:tw-bg-blue-800 focus:tw-ring-4 focus:tw-outline-none focus:tw-ring-blue-300 tw-font-medium tw-rounded-lg tw-text-sm tw-px-4 tw-py-2 dark:tw-bg-blue-600 dark:hover:tw-bg-blue-700 dark:focus:tw-ring-blue-800"
                >
                  Search
                </button>
              </div>
            </form>
          </div>
          <div className="tw-w-[90%] tw-relative tw-mx-auto tw-bg-[#FFFFFF] tw-shadow-3xl tw-rounded-xl  tw-py-7">
            <div className="tw-w-[90%] tw-mx-auto ">
              {/* 1st item */}
              <div className="tw-flex tw-items-center tw-justify-between tw-mb-5">
                <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold tw-flex tw-items-center">
                  Customer Name
                  {downOpenForUser ? (
                    <ExpandMoreIcon onClick={descUserSortHandler} className={`${downOpenForUser ? "tw-hidden" : ""}`} />
                  ) : (
                    <ExpandLessIcon onClick={ascUserSortHandler} className={`${downOpenForUser ? "" : "tw-hidden"}`} />
                  )}
                </div>
                <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold tw-flex tw-gap-2 tw-items-center">
                  Pet Name
                  {downOpenForPet ? (
                    <ExpandMoreIcon onClick={descPetSortHandler} className={`${downOpenForPet ? "tw-hidden" : ""}`} />
                  ) : (
                    <ExpandLessIcon onClick={ascPetSortHandler} className={`${downOpenForPet ? "" : "tw-hidden"}`} />
                  )}
                </div>
                <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">Risk Level</div>
                <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">Risk Value</div>
                <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold"></div>
              </div>
              {/* 2nd item */}
              {tests && tests?.length !== 0 ? (
                <>
                  {sortedResults && sortedResults?.length > 0
                    ? sortedResults?.map((item: any, index: any) => (
                        <LabResultRow
                          isSubmitted={item.submit}
                          result={item}
                          setSubmitted={setSubmitted}
                          key={item._id}
                        />
                      ))
                    : tests &&
                      tests?.length > 0 &&
                      tests?.map((item: any, index) => (
                        <LabResultRow isSubmitted={item.submit} result={item} setSubmitted={setSubmitted} key={index} />
                      ))}
                  {/* <div className="tw-w-full md:tw-w-full tw-m-auto tw-flex tw-flex-col md:tw-flex-row tw-gap-[1rem] tw-items-center md:tw-justify-between sm:tw-justify-center tw-px-[3%] tw-mt-[2rem]">
                    <div className="">
                      <p className="tw-text-base tw-text-tabelHeadingColor tw-font-fontPara tw-font-medium">
                        {`Showing ${testLength}
                           of ${records}`}
                      </p>
                    </div>
                    <div className="flex flex-row gap-[0.5rem] tw-items-center">
                      <button
                        onClick={decrementPageHandler}
                        disabled={pageValue.start <= 1 ? true : false}
                        className={
                          pageValue.start <= 1
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                            : "tw-px-[0.5rem] md:tw-px-[1.05rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-sm md:tw-text-md tw-rounded-md tw-text-white tw-font-fontHeading tw-font-bold tw-bg-reddishOrange tw-mr-1"
                        }
                      >
                        <KeyboardDoubleArrowLeftIcon />
                      </button>
                      <button
                        disabled={pageValue.start > pages ? true : false}
                        className={
                          pageValue.start === activePage
                            ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-2"
                            : pageValue.start > pages
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-2"
                            : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md tw-mr-2 hover:tw-bg-reddishOrange hover:tw-text-white"
                        }
                        onClick={() => onPageClickHandler(pageValue.start)}
                      >
                        {pageValue.start}
                      </button>
                      <button
                        disabled={pageValue.second > pages ? true : false}
                        className={
                          pageValue.second === activePage
                            ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-2"
                            : pageValue.second > pages
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-2"
                            : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md tw-mr-2 hover:tw-bg-reddishOrange hover:tw-text-white"
                        }
                        onClick={() => onPageClickHandler(pageValue.second)}
                      >
                        {pageValue.second}
                      </button>
                      <button
                        disabled={pageValue.end > pages ? true : false}
                        className={
                          pageValue.end === activePage
                            ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-1"
                            : pageValue.end > pages
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                            : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md hover:tw-bg-reddishOrange hover:tw-text-white tw-mr-1"
                        }
                        onClick={() => onPageClickHandler(pageValue.end)}
                      >
                        {pageValue.end}
                      </button>
                      <button
                        onClick={incrementPageHandler}
                        disabled={pageValue.end >= pages ? true : false}
                        className={
                          pageValue.end >= pages
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                            : "tw-px-[0.5rem] md:tw-px-[1.05rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-sm md:tw-text-md tw-rounded-md tw-text-white tw-font-fontHeading tw-font-bold tw-bg-reddishOrange tw-mr-1"
                        }
                      >
                        <KeyboardDoubleArrowRightIcon />
                      </button>
                    </div>
                  </div> */}
                </>
              ) : (
                ""
              )}
              {loading && <Loader />}
              {!loading && tests && tests?.length === 0 && "No Result Found"}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default LabResultTable;
